import { render, staticRenderFns } from "./corporate-style.vue?vue&type=template&id=3ac7f32f&scoped=true&"
import script from "./corporate-style.vue?vue&type=script&lang=js&"
export * from "./corporate-style.vue?vue&type=script&lang=js&"
import style0 from "./corporate-style.vue?vue&type=style&index=0&id=3ac7f32f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac7f32f",
  null
  
)

export default component.exports